<style scoped>
  .line{margin:10px auto}
  .text-key{text-align: right}
</style>
<template>
  <div>
    <Collapse simple :value="[1,2,3]">
      <Panel name="1">
        委托方身份信息
        <div slot="content">
          <template v-for="(item,index) in client">
            <Row type="flex" align="middle">
              <Col span="20">
                <Row type="flex" align="middle" class="line">
                  <Col span="3" offset="1" class="text-key">身份类型<span style="color: red">*</span></Col>
                  <Col span="5" offset="1">
                    <Select v-model="item.identity" style="width:100px">
                      <Option v-for="item in identity" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </Col>
                  <Col span="3" offset="1" class="text-key">
                    名称<span style="color: red">*</span>
                  </Col>
                  <Col span="5" offset="1">
                    <Input v-model="item.name" placeholder="为便于利益审查，请务必准确完整填写"></Input>
                  </Col>
                </Row>
                <Row type="flex" align="middle" class="line">
                  <Col span="3" offset="1" class="text-key">委托人诉讼地位<span style="color: red">*</span></Col>
                  <Col span="5" offset="1">
                    <Select v-model="item.litigation" style="width:100px">
                      <Option v-for="item in litigation" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </Col>
                  <template  v-if="$route.query.detailed">
                    <Col span="3" offset="1" class="text-key">识别号码</Col>
                    <Col span="5" offset="1">
                      <Input v-model="item.IDCardCode" placeholder="身份证号/营业执照"></Input>
                    </Col>
                  </template>
                </Row>
              </Col>
              <Col span="4">
                <div style="cursor: pointer;color:#bbb" v-if="client.length>1" @click="client.splice(index,1)"><Icon type="md-close"/>删除</div>
                <div style="cursor: pointer;color:#bbb" v-if="index==client.length-1" @click="client.push({name:'',IDCardCode:'',identity:'personal',litigation:'',})"><Icon type="md-add"/>新增委托方</div>
                <!--<Button v-if="client.length>1" type="error" @click="client.splice(index,1)" icon="md-close">删除</Button>-->
              </Col>
            </Row>
            <Divider v-if="index!=client.length-1" :dashed="true"/>
          </template>
          <!--<div style="text-align: right">-->
            <!--<Button type="success" style="width:80px" @click="client.push({name:'',IDCardCode:'',identity:'personal',litigation:'',})" icon="md-add">增 加</Button>-->
          <!--</div>-->
        </div>
      </Panel>
      <Panel name="2">
        对方身份信息
        <div slot="content">
          <template v-for="(item,index) in opposed">
            <Row type="flex" align="middle">
              <Col span="20">
                <Row type="flex" align="middle" class="line">
                  <Col span="3" offset="1" class="text-key">身份类型</Col>
                  <Col span="5" offset="1">
                    <Select v-model="item.identity" style="width:100px">
                      <Option v-for="item in identity" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </Col>
                  <Col span="3" offset="1" class="text-key">
                    名称<span style="color: red">*</span>
                  </Col>
                  <Col span="5" offset="1">
                    <Input v-model="item.name" placeholder="为便于利益审查，请务必准确完整填写"></Input>
                  </Col>
                </Row>
                <Row type="flex" align="middle" class="line">
                  <Col span="3" offset="1" class="text-key">诉讼地位</Col>
                  <Col span="5" offset="1">
                    <Select v-model="item.litigation" style="width:100px">
                      <Option v-for="item in litigation" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </Col>
                  <template v-if="$route.query.detailed">
                    <Col span="3" offset="1" class="text-key">识别号码</Col>
                    <Col span="5" offset="1">
                      <Input v-model="item.IDCardCode" placeholder="身份证号/营业执照"></Input>
                    </Col>
                  </template>
                </Row>
              </Col>
              <Col span="4">
                <div style="cursor: pointer;color:#bbb" v-if="opposed.length>1" @click="opposed.splice(index,1)"><Icon type="md-close"/>删除</div>
                <div style="cursor: pointer;color:#bbb" v-if="index==opposed.length-1" @click="opposed.push({name:'',IDCardCode:'',identity:'personal',litigation:'',})"><Icon type="md-add"/>新增对方信息</div>
                <!--<Button v-if="opposed.length>1" type="error" @click="opposed.splice(index,1)" icon="md-close">删除</Button>-->
              </Col>
            </Row>
            <Divider v-if="index!=opposed.length-1" :dashed="true"/>
          </template>
          <!--<div style="text-align: right">-->
            <!--<Button type="success" style="width:80px" @click="opposed.push({name:'',IDCardCode:'',identity:'personal',litigation:'',})" icon="md-add">增 加</Button>-->
          <!--</div>-->
        </div>
      </Panel>
    </Collapse>
    <div style="padding:10px"></div>
    <div style="text-align: right"><Checkbox v-model="checkConflict" true-value="check" false-value="uncheck">利冲检索</Checkbox></div>
    <div style="padding:10px"></div>
    <Row :gutter="20" type="flex" justify="center">
      <Col span="4">
        <Button type="primary" style="width:100%" :disabled="true">上一步</Button>
      </Col>
      <Col span="4">
        <Button @click="nextStep()" type="primary" style="width:100%;">下一步</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
  export default {
    name: "step1",//基础信息填写
    props:{
      nextRoute:String,
    },
    data:function () {
      return{
        litigation:[
          {value:'plaintiff',label:'原告'},
          {value:'accused',label:'被告'},
        ],
        identity:[
          {value:'personal',label:'个人'},
          {value:'company',label:'单位'},
        ],
        checkConflict:'check',
      }
    },
    mounted:function(){
      this.getLitigationStatus()
    },
    methods:{
      nextStep:function () {
        for(var i=0;i<this.client.length;i++){
          if(this.isEmpty(this.client[i].name)||this.isEmpty(this.client[i].identity)||this.isEmpty(this.client[i].litigation)){
            this.$Modal.warning({
              title:'系统提示',
              content:'名称与身份类型不能为空！'
            })
            return
          }
        }
        // for(var i=0;i<this.opposed.length;i++){
        //   if(this.isEmpty(this.opposed[i].name)||this.isEmpty(this.opposed[i].identity)||this.isEmpty(this.opposed[i].litigation)){
        //     this.$Modal.warning({
        //       title:'系统提示',
        //       content:'名称与身份类型不能为空！'
        //     })
        //     return
        //   }
        // }
        this.$router.push({name:'adviserStep2',query:{id:this.$route.query.id,detailed:this.$route.query.detailed,checkConflict:this.checkConflict}})
      },
      getLitigationStatus:function () {
        var _this = this
        _this.send({
          headers:'C/ShowIdentity',
          success:function (res) {
            _this.identity = []
            for(var index in res.LitigantTypeTitle){
              _this.identity.push({type:res.LitigantTypeTitle[index].LitigantTypeNature,value:res.LitigantTypeTitle[index].LitigantTypeId,label:res.LitigantTypeTitle[index].LitigantTypeTitle})
            }
            _this.litigation = []
            for(var index in res.LitigationLawsuit){
              _this.litigation.push({value:res.LitigationLawsuit[index].LitigationLawsuitId,label:res.LitigationLawsuit[index].LitigationLawsuitName})
            }
            if(_this.client.length<1){
              _this.client.push({name:'',IDCardCode:'',identity:'personal',litigation:'',})
            }
            if(_this.opposed.length<1){
              _this.opposed.push({name:'',IDCardCode:'',identity:'personal',litigation:'',})
            }
          }
        })
      }
    },
    computed:{
      client:function () {
        return this.$store.state.project.create.step1.client
      },
      opposed:function () {
        return this.$store.state.project.create.step1.opposed
      },
    }
  }
</script>